import { MenuEntry } from '@europrocurement/flexy-components';
import { dossiersBasePath, ordersBasePath } from '@europrocurement/l2d-modules';
import { FORMALITIES_INVOICES_LIST } from '../Factures';

export const FormalitiesMenuEntries: MenuEntry[] = [
    {
        title: 'Formalités',
        icon: 'folders',
        role: 'realm:interne',
        children: [
            {
                title: 'Dossiers',
                icon: 'folders',
                href: `/${dossiersBasePath}`,
            },
            {
                title: 'Commandes',
                icon: 'file-lines',
                href: `/${ordersBasePath}`,
            },
            {
                title: 'Factures',
                icon: 'file-invoice',
                href: FORMALITIES_INVOICES_LIST,
            },
            {
                title: 'Nouveau Dossier',
                icon: 'folder-plus',
                href: '/newformality/prescripteur',
            },
        ],
    },
];
